module.exports = __webpack_public_path__ + "img/Brocard.968951ef.png";